export default __webpack_public_path__ + "static/media/Breast cancer.ba5d1484.png";